import { useSession } from "@core/hooks/useSession";
import IdentifyDatadogRumUser from "@core/utils/IdentifyDatadogRumUser";
import IdentifySentryUser from "@core/utils/IdentifySentryUser";
import ThirdPartyAuthController from "@features/auth/components/ThirdPartyAuthController";
import { FC } from "react";

const SideEffects: FC = () => {
  const { data: session } = useSession();

  const isAuthenticated = !!session?.accessToken;

  return (
    <>
      {isAuthenticated && <ThirdPartyAuthController key="3rd-party-auth" />}
      {isAuthenticated && <IdentifySentryUser key="sentry-user-watcher" />}
      {isAuthenticated && <IdentifyDatadogRumUser key="dd-user-watcher" />}
    </>
  );
};

export default SideEffects;
